import { CheckboxRadioCode } from '../codeHighlights/forms/CheckboxeRadioCode';

const CheckboxesRadios = () => {
  return (
    <>
      <h2>Checkboxes and radios</h2>
      <div className="my-3">
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="exampleRadios"
            id="exampleRadios1"
            value="option1"
            checked
            onChange={e => {}}
          />
          <label className="form-check-label" htmlFor="exampleRadios1">
            Default radio
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="exampleRadios"
            id="exampleRadios2"
            value="option2"
          />
          <label className="form-check-label" htmlFor="exampleRadios2">
            Second default radio
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="exampleRadios"
            id="exampleRadios3"
            value="option3"
            disabled
          />
          <label className="form-check-label" htmlFor="exampleRadios3">
            Disabled radio
          </label>
        </div>
      </div>

      <div className="my-3">
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDefault"
          />
          <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
            Default switch checkbox input
          </label>
        </div>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckChecked1"
            checked
            onChange={e => {}}
          />
          <label className="form-check-label" htmlFor="flexSwitchCheckChecked1">
            Checked switch checkbox input
          </label>
        </div>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckDisabled2"
            disabled
          />
          <label
            className="form-check-label"
            htmlFor="flexSwitchCheckDisabled2"
          >
            Disabled switch checkbox input
          </label>
        </div>
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="flexSwitchCheckCheckedDisabled3"
            checked
            disabled
            onChange={e => {}}
          />
          <label
            className="form-check-label"
            htmlFor="flexSwitchCheckCheckedDisabled3"
          >
            Disabled checked switch checkbox input
          </label>
        </div>
      </div>

      <div className="mb-3 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="exampleCheck1"
        />
        <label className="form-check-label" htmlFor="exampleCheck1">
          Check me out
        </label>
      </div>

      <div className="mt-5">
        <CheckboxRadioCode />
      </div>
    </>
  );
};

export default CheckboxesRadios;
